// The mobile run-detail PAGE is addressed by a search param, not a path segment.
//
// RSAAnalysis renders in two hosts — the standalone /RSA-Analysis route and,
// embedded, inside ProjectView at /projects/:id — so a path route like
// /RSA-Analysis/run/:id would only ever cover the first one. ProjectView already
// treats the URL as the single source of truth for RSA sub-state (rsa_view /
// rsa_tab) and its updateRsaRouteState() rebuilds the query from the CURRENT
// search while touching only its own keys, so this one rides along untouched
// through tab and view changes.
//
// Three modules share the key: RSAAnalysis (opens the page and derives it),
// MobileBottomBar (its Back button closes the page), and their tests. It lives
// here so none of them has to import from the others.

export const RSA_RUN_QUERY_KEY = 'rsa_run';

/** The open run's id, or null when the run page is closed. */
export const getRsaRunFromSearch = (search = '') => {
  const raw = new URLSearchParams(search).get(RSA_RUN_QUERY_KEY);
  return String(raw ?? '').trim() || null;
};

/** Same query string with the run page opened on `runId`. */
export const searchWithRsaRun = (search = '', runId) => {
  const params = new URLSearchParams(search);
  params.set(RSA_RUN_QUERY_KEY, String(runId));
  const next = params.toString();
  return next ? `?${next}` : '';
};

/** Same query string with the run page closed. */
export const searchWithoutRsaRun = (search = '') => {
  const params = new URLSearchParams(search);
  params.delete(RSA_RUN_QUERY_KEY);
  const next = params.toString();
  return next ? `?${next}` : '';
};

/**
 * Bottom-bar Back -> run page. The bar knows a run page is open (it reads the
 * param) but not how it was opened, and only RSAAnalysis knows whether it
 * pushed a history entry it may safely pop. So the bar ASKS rather than acts:
 * the event is cancelable, and a handler that closes the page calls
 * preventDefault() to claim it. dispatchEvent() then returns false, which is
 * the bar's signal to stand down.
 *
 * Without the handshake a stale param (deep link into a non-RSA project, where
 * RSAAnalysis never mounts) would leave Back doing nothing at all.
 */
export const RSA_RUN_PAGE_BACK_EVENT = 'rsa:mobile-run-page-back';
